import React, { useEffect, useState } from 'react';
import './EmailPopUp.scss';
import RadioButton from 'Components/common/RadioBtn';
import profileState from 'Stores/profile';
import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/style.css';
import 'Styles/layout/_fieldMapping.scss';
import { ReactComponent as CrossIcon } from 'Assets/usageAnalytics/cross-icon.svg';
import { ReactComponent as InfoIcon } from 'Assets/usageAnalytics/info-icon.svg';
import { ReactComponent as CheckIcon } from 'Assets/svg/tick-icon-new.svg';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import * as CONSTANTS from 'Utils/constants';
import Utils from 'Utils/utils';
import SetEmailNotification from 'Components/common/setEmailNotification/setEmailNotification';

function getTime(time) {
  return CONSTANTS.time.find(data => data.value === time).label || time;
}

const EmailPopUp = React.forwardRef((props, ref) => {
  const { value, onClose, index } = props;
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [recepients, setRecepients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hoverPopup, setHoverPopUp] = useState(false);
  const [dateRange, setDateRange] = useState('CURRENT_MONTH');
  const [initialData, setInitialData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);
  const [emailNotification, setEmailNotification] = useState({
    selectedTime: 'Weekly',
    ordinalDay: 'First',
    day: 'Monday',
    time: '11:00 AM',
    timeZone: 'GMT',
  });

  useEffect(() => {
    (async () => {
      if (index !== null) {
        setIsLoading(true);
        const response = await profileState.getRecurringDataById(index);
        if (response.status === 200) {
          const {
            name: reportName,
            subject: mailSubject,
            message: ReportMessage,
            recepients: addedRecipients,
            frequency,
            day: selectedDay,
            time: selectedTime,
            ordinalDay: selectedOrdinalDay,
            timeZone: selectedTimeZone,
            dateRange: selectedDateRange,
          } = response.data;
          setName(reportName);
          setSubject(mailSubject);
          setInitialData(response.data);
          setMessage(ReportMessage);
          setRecepients(addedRecipients);
          setEmailNotification(previousState => {
            return {
              ...previousState,
              selectedTime: frequency === 'MONTHLY' ? 'Monthly' : 'Weekly',
              day: selectedDay
                .toLowerCase()
                .replace(/\b(\w)/g, s => s.toUpperCase()),
              time: selectedTime,
              ordinalDay: selectedOrdinalDay
                ? selectedOrdinalDay
                    .toLowerCase()
                    .replace(/\b(\w)/g, s => s.toUpperCase())
                : 'First',
              timeZone: selectedTimeZone,
            };
          });
          setDateRange(selectedDateRange);
          setIsLoading(false);
        }
      }
    })();
  }, []);
  const handleOnChangeEmail = (type, emailValue) => {
    setEmailNotification(prevState => {
      return {
        ...prevState,
        [type]: emailValue,
      };
    });
  };

  const handleOnClickSchedule = async () => {
    setIsLoading(true);
    let response;
    if (index === null) {
      if (
        recepients.length > 0 &&
        (((name || '').length > 0 && value === 'Email Digest') ||
          value === 'One-Time Email')
      ) {
        if (value !== 'One-Time Email') {
          response = await profileState.createRecurringEmail({
            name,
            subject,
            message,
            recepients,
            type: 'RECURRING',
            frequency:
              emailNotification.selectedTime === 'Weekly'
                ? 'WEEKLY'
                : 'MONTHLY',
            day: emailNotification.day.toUpperCase(),
            ...(emailNotification.selectedTime !== 'Weekly' && {
              ordinalDay: emailNotification.ordinalDay.toUpperCase(),
            }),
            time: emailNotification.time,
            timeZone: emailNotification.timeZone,
            dateRange,
          });
          if (response.status !== 200 || response.status !== 201)
            onClose(
              value !== 'One-Time Email'
                ? 'Error While creating the email digest'
                : 'Error while sending the email',
              'failure',
            );
        } else {
          response = await profileState.createRecurringEmail({
            subject,
            message,
            recepients,
            type: 'ONE_TIME',
            dateRange,
          });
          if (response?.status !== 200 || response?.status !== 201)
            onClose('Error while creating  the email', 'failure');
        }
        if (response?.status === 200 || response?.status === 201) {
          Utils.mixpanelTrack(
            value !== 'One-Time Email'
              ? CONSTANTS.MX_EMAIL_DIGEST_EVENTS.EMAIL_DIGEST_CREATE
              : CONSTANTS.MX_EMAIL_DIGEST_EVENTS.ONE_TIME_EMAIL_CREATE,
          );
          onClose(
            value !== 'One-Time Email'
              ? 'Your email digest has been created successfully.'
              : 'Email has been sent successfully.',
            'success',
            'isUsageAnalyticsMessage',
          );
        }
      } else {
        setErrorMessage(true);
      }
    } else {
      const newObj = { id: index };
      if (initialData.name.length !== name.length) newObj.name = name;
      if (initialData.subject.length !== subject.length)
        newObj.subject = subject;
      if (initialData.message.length !== message.length)
        newObj.message = message;
      if (initialData.recepients.length !== recepients.length)
        newObj.recepients = recepients;
      else
        for (let i = 0; i < recepients.length; i = +1)
          if (recepients[i] !== initialData.recepients[i]) {
            newObj.recepients = recepients;
            break;
          }
      if (
        initialData.frequency !== emailNotification.selectedTime.toUpperCase()
      )
        newObj.frequency = emailNotification.selectedTime.toUpperCase();
      if (initialData.day !== emailNotification.day.toUpperCase())
        newObj.day = emailNotification.day.toUpperCase();
      if (initialData.ordinalDay !== emailNotification.ordinalDay.toUpperCase())
        newObj.ordinalDay = emailNotification.ordinalDay.toUpperCase();
      if (initialData.time !== emailNotification.time)
        newObj.time = emailNotification.time;
      if (initialData.timeZone !== emailNotification.timeZone)
        newObj.timeZone = emailNotification.timeZone;
      if (initialData.dateRange !== dateRange) newObj.dateRange = dateRange;
      response = await profileState.updateRecurringEmail(newObj);

      if (
        response?.status === 200 ||
        response?.status === 201 ||
        response?.status === 202
      ) {
        Utils.mixpanelTrack(
          CONSTANTS.MX_EMAIL_DIGEST_EVENTS.EMAIL_DIGEST_UPDATE,
        );
        onClose(
          'Your changes have been successfully saved!',
          'success',
          'isUsageAnalyticsMessage',
        );
      } else {
        onClose('Error while saving the changes', 'failure');
      }
    }
    setIsLoading(false);
  };
  return (
    <>
      <div className=" common-popup EmailContainer email-schedule-popup">
        <LoadingWrapper position="fixed" show={isLoading} />
        <div className="header-container">
          <h4>{value}</h4>
          <div>
            <CrossIcon onClick={() => onClose('', '')} />
          </div>
        </div>
        <div className="first-sub-container">
          {value !== 'One-Time Email' && (
            <div className="subject-container">
              <div className="email-digest-container">
                <h5>
                  Name of the Email Digest<sup>*</sup>
                </h5>
                <span className="footerText">(Recepients won’t see this)</span>
              </div>
              <input
                type="text"
                value={name}
                className={`digest-name${
                  errorMessage && (name || '').length === 0 ? ' error' : ''
                }`}
                placeholder="Name of the Email Digest"
                onChange={e => {
                  setName(e.target.value);
                }}
              />
              {errorMessage && (name || '').length === 0 && (
                <div className="error-message">
                  Please enter name for email digest
                </div>
              )}
            </div>
          )}
          <div
            className={`subject-container${
              value === 'One-Time Email' ? ' one-time-email' : ''
            }`}
          >
            <h5>Email Subject</h5>
            <input
              className={`subject${
                value === 'One-Time Email' ? '' : ' recurring'
              }`}
              type="text"
              value={subject}
              placeholder="Subject for the email"
              onChange={e => {
                setSubject(e.target.value);
              }}
            />
          </div>
        </div>
        <div
          className="messageContainer"
          id={value !== 'One-Time Email' ? 'message-container-input' : ''}
        >
          <div>
            <h5>Message</h5>
            <p>{message.length}/200 characters</p>
          </div>
          <textarea
            maxLength="200"
            name="textarea"
            value={message}
            placeholder="Type in your message for the email here."
            onChange={e => {
              setMessage(e.target.value);
            }}
          />
        </div>
        <div
          className="recepientsContainer"
          id={
            value !== 'One-Time Email'
              ? 'reciepientsContainer-for-recurring'
              : ''
          }
        >
          <div>
            <h5>Recepients*</h5>
            {recepients.length > 0 && (
              <div className="recepients-added">
                <CheckIcon />
                <span>{recepients.length} Added</span>
              </div>
            )}
          </div>
          <ReactMultiEmail
            emails={recepients}
            placeholder="Enter email id."
            className={`react-email-tag${
              errorMessage && recepients.length === 0 ? ' error' : ''
            }`}
            onChange={_emails => {
              setRecepients(_emails);
            }}
            getLabel={(email, i, removeEmail) => {
              return (
                <div data-tag key={i}>
                  {email}
                  <span data-tag-handle onClick={() => removeEmail(i)}>
                    ×
                  </span>
                </div>
              );
            }}
          />
          {errorMessage && recepients.length === 0 && (
            <div className="error-message">
              Please enter atleast one email address.
            </div>
          )}
        </div>
        <div
          className="time-container"
          id={value !== 'One-Time Email' ? 'time-container-for-recurring' : ''}
        >
          {value !== 'One-Time Email' && (
            <SetEmailNotification
              customTitle="Frequency"
              handleChangeRadio={handleOnChangeEmail}
              selectedEmailValues={emailNotification}
            />
          )}
          {value !== 'One-Time Email' && <div className="marginBothSides" />}

          <div className="time-period-text">
            <h5>Time Period</h5>
            <InfoIcon
              onMouseEnter={() => setHoverPopUp(true)}
              onMouseLeave={() => setHoverPopUp(false)}
            />
            {hoverPopup === true && (
              <div>
                Report will be generated based on the selected time period.
              </div>
            )}
          </div>
          <div className="time-period-container">
            <RadioButton
              name="Time Period"
              id="Current Month"
              label="Current Month"
              value="Current Month"
              checked={dateRange === 'CURRENT_MONTH' ? 'checked' : ''}
              onChange={data => {
                setDateRange('CURRENT_MONTH');
              }}
            />
            <RadioButton
              name="Time Period"
              id="Current + Last 1 Month"
              label="Current + Last 1 Month"
              value="Current + Last 1 Month"
              checked={
                dateRange === 'CURRENT_PLUS_LAST_ONE_MONTH' ? 'checked' : ''
              }
              onChange={data => {
                setDateRange('CURRENT_PLUS_LAST_ONE_MONTH');
              }}
            />
            <RadioButton
              name="Time Period"
              id="Current + Last 2 Month"
              label="Current + Last 2 Months"
              value="Current + Last 2 Months"
              checked={
                dateRange === 'CURRENT_PLUS_LAST_TWO_MONTH' ? 'checked' : ''
              }
              onChange={data => {
                setDateRange('CURRENT_PLUS_LAST_TWO_MONTH');
              }}
            />
          </div>
        </div>
        <div className="marginBothSides" />
        {value === 'One-Time Email' && (
          <div className="footerContainer">
            <p className="footerText">This email will be sent only once.</p>
            <div>
              <button
                className="new-button"
                type="button"
                onClick={() => onClose('', '')}
              >
                Cancel
              </button>
              <button
                className="new-green-button"
                type="button"
                onClick={handleOnClickSchedule}
              >
                Send Email
              </button>
            </div>
          </div>
        )}
        {value !== 'One-Time Email' && (
          <div className="footerContainer">
            {emailNotification.selectedTime === 'Weekly' ? (
              <p className="footerText">
                {`This email is scheduled to send every week on ${
                  emailNotification.day
                } at ${getTime(emailNotification.time)} ${
                  emailNotification.timeZone
                }.`}
              </p>
            ) : (
              <p className="footerText">
                {`This email is scheduled to send every month on ${
                  emailNotification.ordinalDay
                } ${emailNotification.day} at ${getTime(
                  emailNotification.time,
                )} ${emailNotification.timeZone}.`}
              </p>
            )}
            <div>
              <button
                className="new-button"
                type="button"
                onClick={() => onClose('', '')}
              >
                Cancel
              </button>
              <button
                className="new-green-button schedule-email"
                type="button"
                onClick={handleOnClickSchedule}
              >
                Schedule Email
              </button>
            </div>
          </div>
        )}
      </div>
      <div
        className="common-popup-mask common-back-ground"
        onClick={() => onClose('', '')}
      />
    </>
  );
});

export default EmailPopUp;
